import { Component } from '@angular/core';

@Component({
  selector: 'app-manage-record-layout',
  templateUrl: './manage-record-layout.component.html'
})
export class ManageRecordLayoutComponent {}
